import { render, staticRenderFns } from "./setFutures.vue?vue&type=template&id=be761396&"
import script from "./setFutures.vue?vue&type=script&lang=js&"
export * from "./setFutures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports